/* eslint-disable prettier/prettier */
/* eslint-disable import/no-cycle */
import { Injectable } from '@angular/core';

import { buildMenu } from '@app/app-components';
import { IRoute, MenuService, RouterItemPg } from 'viggo-sistemas-core-web';
import { CompareItemMenu } from 'viggo-sistemas-core-web/modules/side-menu/model/compare-routers.model';
import { MenuAdmin } from './menu-admin/menu_admin';
import { MenuSysadmin } from './menu-sysadmin/menu_sysadmin';

/**
 * Ordena 2 itens de menu em ordem alfabética
 */
export const ordemAlfabetica = (a: RouterItemPg, b: RouterItemPg) =>
  a.label > b.label ? 1 : -1;

export const ordemPrecendecia = (a: RouterItemPg, b: RouterItemPg) =>
  a.precedence > b.precedence ? 1 : -1;

export const ordemPrecendeciaMenu = (a: buildMenu, b: buildMenu) =>
  a.precedence > b.precedence ? 1 : -1;

@Injectable()
export class CustomMenuService extends MenuService {
  // defina suas rotas aqui;
  protected createDynamicsMenuPg(routes: IRoute[]): RouterItemPg[] {
    /**
     * é requirido que você chame a classe super para definir as rotas padrões
     */
    let defaultMenu = super.createDynamicsMenuPg(routes);

    // SYSADMIN

    const localizacaoMenu = new MenuSysadmin().createLocalizacaoMenu(routes);
    if (localizacaoMenu) defaultMenu = defaultMenu.concat(localizacaoMenu);

    const precificacaoMenu = new MenuSysadmin().createPrecificacaoMenu(routes);
    if (precificacaoMenu) defaultMenu = defaultMenu.concat(precificacaoMenu);

    // ADMIN

    const parametrizacaoMenu = new MenuAdmin(this.tokenService).createMenuCadastros(routes);
    if (parametrizacaoMenu) defaultMenu = defaultMenu.concat(parametrizacaoMenu);

    const materiaPrimaMenu = new MenuAdmin(this.tokenService).createMateriaPrimaMenu(routes);
    if (materiaPrimaMenu) defaultMenu = defaultMenu.concat(materiaPrimaMenu);

    const produtoMenu = new MenuAdmin(this.tokenService).createProdutoMenu(routes);
    if (produtoMenu) defaultMenu = defaultMenu.concat(produtoMenu);

    const depositoMenu = new MenuAdmin(this.tokenService).createDepositoMenu(routes);
    if(depositoMenu) defaultMenu = defaultMenu.concat(depositoMenu);

    const pedidoProducaoMenu = new MenuAdmin(this.tokenService).createMenuPedidosProducao(routes);
    if (pedidoProducaoMenu) defaultMenu = defaultMenu.concat(pedidoProducaoMenu);

    const orcamentoMenu = new MenuAdmin(this.tokenService).createMenuOrcamento(routes);
    if (orcamentoMenu) defaultMenu = defaultMenu.concat(orcamentoMenu);

    const financeiroMenu = new MenuAdmin(this.tokenService).createMenuFinanceiro(routes);
    if (financeiroMenu) defaultMenu = defaultMenu.concat(financeiroMenu);

    const reportMenu = new MenuAdmin(this.tokenService).createMenuReport(routes);
    if (reportMenu) defaultMenu = defaultMenu.concat(reportMenu);

    const configMenu = new MenuAdmin(this.tokenService).createMenuConfiguracoes(routes);
    if (configMenu) defaultMenu = defaultMenu.concat(configMenu);

    const vendasMenu = new MenuAdmin(this.tokenService).createMenuVendas(routes);
    if(vendasMenu) defaultMenu = defaultMenu.concat(vendasMenu);

    return defaultMenu;
  }
}

/**
 * Faz um filtro dos itens que podem ser mostrados no menu
 * @param backendRoutes lista de rotas vindas do backend
 * @param routeDefs rotas a serem checadas
 */
export function filterGrantMenuItens(
  backendRoutes: IRoute[],
  routeDefs: CompareItemMenu[]
): RouterItemPg[] {
  const cloneBackendRoutes = [...backendRoutes];

  return routeDefs
    .filter(item => {
      return item.matchBackendRoutes.some(matchItem => {
        const compareKeys = Object.keys(matchItem);

        if (compareKeys.length === 0) return false;

        return cloneBackendRoutes.some(backendRoute =>
          compareKeys.reduce(
            (previous, currentKey) =>
              previous && matchItem[currentKey] === backendRoute[currentKey],
            true
          )
        );
      });
    })
    .map(item => item.menuItem);
}

/**
 * Faz um filtro dos itens que podem ser mostrados no menu
 * @param backendRoutes lista de rotas vindas do backend
 * @param routeDefs rotas a serem checadas
 */
export function filterGrantSubMenuItens(
  backendRoutes: IRoute[],
  routeDefs: CompareItemMenu[]
): RouterItemPg[] {
  const cloneBackendRoutes = [...backendRoutes];

  return routeDefs
    .filter(item => {
      if (item.menuItem.isSubMenu) {
        item.menuItem.items = item.menuItem.items.filter(itemSubMenu => {
          return itemSubMenu.backend_config.some(matchItem => {
            const compareKeys = Object.keys(matchItem);
            if (compareKeys.length === 0) return false;

            return cloneBackendRoutes.some(backendRoute =>
              compareKeys.reduce(
                (previous, currentKey) =>
                  previous &&
                  matchItem[currentKey] === backendRoute[currentKey],
                true
              )
            );
          });
        });
        return item.menuItem.items.length > 0;
      } else {
        return item.matchBackendRoutes.some(matchItem => {
          const compareKeys = Object.keys(matchItem);

          if (compareKeys.length === 0) return false;

          return cloneBackendRoutes.some(backendRoute =>
            compareKeys.reduce(
              (previous, currentKey) =>
                previous && matchItem[currentKey] === backendRoute[currentKey],
              true
            )
          );
        });
      }
    })
    .map(item => item.menuItem);
}
